import { NotificationAdapter } from "../Notification/NotificationAdapter";
import toastr from "./toastr";
import {toastrOptions} from "./toastrOptions";

let openedToasts: (HTMLElement | null)[] = [];

export class ToastrAdapter extends NotificationAdapter {
	clear(clearErrorWarningToastsOnly = false): void {
		if(!clearErrorWarningToastsOnly)
			toastr.clear();
		else {
			for (let i = openedToasts.length - 1; i >= 0; i--)
				toastr.clear(openedToasts[i]);
		}

		openedToasts = [];
	}
	error(message?: string, title = ""): unknown {
		const toast = toastr.error(message, title, toastrOptions.Error);
		openedToasts.push(toast);
		return toast;
	}
	success(message?: string, title = "", overrideOptions = {}): unknown {
		const options = { ...toastrOptions.Success, ...overrideOptions };
		return toastr.success(message, title, options);
	}
	info(message?: string, title = ""): unknown {
		return toastr.info(message, title, toastrOptions.Info);
	}
	warning(message?: string, title = ""): unknown {
		const toast = toastr.warning(message, title, toastrOptions.Warning);
		openedToasts.push(toast);
		return toast;
	}
}
